<p-toast></p-toast>
<div style="width: auto; overflow: auto">

    <div *ngIf="env.applicationType === 'viverogest'" class="d-flex gap-4 flex-row align-self-end m-0 text-black mb-2">
        <div class="d-flex flex-column justify-content-center align-content-center p-0 m-0">
            <label>Tipo de planta</label>
            <p-selectbutton
                [options]="optionsTipoPlanta"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="tipoPlantaSelectButton"
                (onChange)="filtrarPorTipoPlanta()"
                aria-labelledby="basic">
            </p-selectbutton>
        </div>
        <div class="d-flex flex-column justify-content-end p-0 m-0">
            <button
                class="btn btn-success"
                (click)="downloadDeclaracion()"
                style="padding: 5px 12px; font-size: .8rem;">
                <i class="fa fa-download"></i>
                Exportar declaración
            </button>
        </div>
    </div>

    <app-common-list-table
        [request]="getRequest"
        [filtering]="filter"
        [cols]="cols"
        [showStockReto]="showStockReto"
        [globalVisualTransform]="globalVisualTransform.bind(this)"
        [globalConditionalStyle]="globalConditionalStyle"
        [actionButtonText]="btnAnadir"
        (actionButtonClick)="add()"
        (emitSearchText)="updateFooter(filter, cols)"
        (visualize)="show('info', $event)"
        (edit)="edit($event)"
        (duplicate)="duplicate($event)"
        (remove)="show('delete', $event)">

        <ng-template #header>
            <div *ngIf="env.appName === 'ingenia'" style="margin-left: 20px;">
                <button
                    class="mx-2 btn btn-info"
                    (click)="downloadCsv()"
                    style="padding: 5px; font-size: .8rem;">
                    <i class="fa fa-download"></i>
                    Exportar listado
                </button>
            </div>
        </ng-template>

        <ng-template #thEnd>
            <th class="rt-col-actions" style="width: 120px;">
                <p class="d-flex justify-content-center mb-0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data>
            <td class="rt-col-actions">
                <div class="w-full d-flex justify-content-center align-items-center gap-4">
                    <app-action-buttons
                        [showDuplicate]="true"
                        (duplicateRowButtonEvent)="duplicate(data.data)"
                        (editRowButtonEvent)="edit(data.data)"
                        (deleteRowButtonEvent)="show('delete', data.data)"
                        (showRowButtonEvent)="show('info', data.data)">
                    </app-action-buttons>
                </div>
            </td>
        </ng-template>

        <ng-template #footer let-col>
            <div style="font-size: 0.75em; text-align: left" *ngIf="['finca_nombre'].includes(col.field)">
                TOTAL:
            </div>

            <div
                *ngIf="['unidades'].includes(col.field)"
                style="font-size: 0.75em; text-align: center; font-weight: bold">
                {{ col?.footer }}
            </div>
        </ng-template>
    </app-common-list-table>
</div>

<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="env.serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

<a id="csvLink" style="display: none;"></a>